import React from "react";
import "./AlreadyJoined.css";
import NativeShare from "./common/NativeShare";

export default function AlreadyJoined({ count }) {
  return (
    <>
      <div className="container">
        {/* <img className="lotus" src="/assets/images/lotus.png" /> */}
        <div className="head_img">
          <img src="/assets/odisha_banner.jpeg" />
        </div>
        <div className="txt-a">
          <h4 className="col-o">
            Thank You for Contributing to Odisha’s Future!
          </h4>
          <p>
            The insights and suggestions you share will be conveyed directly to
            the Prime Minister, driving Odisha’s industrial transformation.
          </p>
          <h3 style={{ marginBottom: "50px", marginTop: "80px" }}>
            {" "}
            Suggestions Submitted : {count}
          </h3>
          {/* <p>अन्य लोगों के साथ साझा करें और सत्र को ऐतिहासिक बनाएं!</p> */}
          {/* <p>इतरांसोबत सामायिक करा आणि सत्राला ऐतिहासिक बनवा!</p> */}
          {/* <p>#MeraBoothSabseMazboot</p> */}
          {/* <NativeShare>
            <button>
              <img src="/assets/images/share.png" />
              साझा करें
            </button>
          </NativeShare> */}
          {/* <div className="line"></div> */}
          {/* <h4 className="col-o">'मेरा बूथ, सबसे मजबूत'</h4> */}
          {/* <p>
            22 जनवरी 2025 को दोपहर 1:00 बजे <br /> पीएम मोदी जी से जुड़ें,
            <br /> केवल नमो ऐप पर !
          </p> */}
          <a
            id="join_btn"
            className="join_btn"
            // onClick={(e) => {
            href="appclick://cancel"
            style={{ "textDecoration": "unset" }}
            // }}
          >
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
}
